import React from 'react';
import ReactDOM from 'react-dom';
import AppRoutes from './appRoutes';

ReactDOM.render(
  <AppRoutes />,
  document.getElementById('root'),
);
